module.exports = __webpack_public_path__ + "img/loading_ball_b.f18b7090.svg";